<app-page-layout>
  <article class="api-info-page">
    <h1>API Usage</h1>
    <!-- <p class="lead">Submit asynchronous SQL jobs, poll status, and download CSV results.</p> -->

    <section>
      <h2>Demo Scripts</h2>
      <p>
        The API can be accessed programmatically via any HTTP client. Python examples are available
        in the
        <a [href]="demoScriptsUrl" target="_blank" rel="noopener noreferrer">
          sbn-maqi-demo-scripts repository</a
        >.
      </p>
    </section>

    <section>
      <h2>Workflow</h2>
      <p>
        Authenticate with your MAQI account, submit a read-only SQL query, poll the job status, and
        download the result CSV when the job reaches <code>success</code> or <code>partial</code>.
      </p>
    </section>

    <section>
      <h2>Endpoints</h2>
      <p><code>POST /api/auth/login</code></p>
      <p><code>POST /api/query</code></p>
      <p><code>GET /api/query/&lt;job_id&gt;</code></p>
    </section>

    <section>
      <h2>Minimal Requests</h2>
      <pre><code>{{ loginSnippet }}</code></pre>
      <pre><code>{{ submitSnippet }}</code></pre>
      <pre><code>{{ statusSnippet }}</code></pre>
    </section>

    <section>
      <h2>Status Values</h2>
      <p>
        <code>queued</code>, <code>processing</code>, <code>success</code>, <code>partial</code>,
        <code>error</code>
      </p>
    </section>
  </article>
</app-page-layout>
